"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useHelpUrl = require("./useHelpUrl");
Object.keys(_useHelpUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useHelpUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useHelpUrl[key];
    }
  });
});